var exports = {
  "modalBackdrop": "Modal.module__modalBackdrop___Vi1BUX",
  "layer": "Modal.module__layer___Vi1BUX",
  "backdropSlot": "Modal.module__backdropSlot___Vi1BUX",
  "positionAbsoluteInsetZero": "Modal.module__positionAbsoluteInsetZero___Vi1BUX",
  "backdropCentered": "Modal.module__backdropCentered___Vi1BUX",
  "focusLock": "Modal.module__focusLock___Vi1BUX",
  "surface": "Modal.module__surface___Vi1BUX",
  "layerFullscreen": "Modal.module__layerFullscreen___Vi1BUX",
  "layerFullscreenMobile": "Modal.module__layerFullscreenMobile___Vi1BUX",
  "layerCentered": "Modal.module__layerCentered___Vi1BUX",
  "root": "Modal.module__root___Vi1BUX",
  "centeredOnMobile": "Modal.module__centeredOnMobile___Vi1BUX",
  "rootAnimating": "Modal.module__rootAnimating___Vi1BUX",
  "medium": "Modal.module__medium___Vi1BUX",
  "small": "Modal.module__small___Vi1BUX",
  "large": "Modal.module__large___Vi1BUX",
  "xlarge": "Modal.module__xlarge___Vi1BUX",
  "fullscreen": "Modal.module__fullscreen___Vi1BUX",
  "layout": "Modal.module__layout___Vi1BUX",
  "header": "Modal.module__header___Vi1BUX",
  "light": "Modal.module__light___Vi1BUX",
  "dark": "Modal.module__dark___Vi1BUX",
  "footer": "Modal.module__footer___Vi1BUX",
  "stretchButtons": "Modal.module__stretchButtons___Vi1BUX",
  "headerInner": "Modal.module__headerInner___Vi1BUX",
  "headerText": "Modal.module__headerText___Vi1BUX",
  "content": "Modal.module__content___Vi1BUX",
  "contentNoPadding": "Modal.module__contentNoPadding___Vi1BUX",
  "screenReaderLabel": "Modal.module__screenReaderLabel___Vi1BUX",
  "insetCloseButtonContainer": "Modal.module__insetCloseButtonContainer___Vi1BUX",
  "insetCloseButton": "Modal.module__insetCloseButton___Vi1BUX",
  "contentLayout": "Modal.module__contentLayout___Vi1BUX",
  "description": "Modal.module__description___Vi1BUX",
  "inputGroup": "Modal.module__inputGroup___Vi1BUX",
  "formFooter": "Modal.module__formFooter___Vi1BUX",
};

__webpack_require__.r(module.exports = exports);
